import {
  saveDataShowSettings,
  saveMapDrawSettings,
  saveZernikeParams,
  saveZernikeSetSettings
} from "../../settings";
import { isDefined, objectCopy } from "../../shared/utils";
Object.keys(window.mapDrawSettings).forEach((key1) => {
  Object.keys(window.mapDrawSettings[key1]).forEach((key2) => {
    delete window.mapDrawSettings[key1][key2]["shapes"]["ShowPupilEdge"];
    delete window.mapDrawSettings[key1][key2]["shapes"]["ShowPupilCenter"];
  });
});
const state = {
  casePath: "",
  zernikeViewParams: {
    maxPeak: { x: -1000, y: -1000 },
    meanRms: { mean: -1000, rms: -1000 }
  },
  dataShowSettings: { ...window.dataShowSettings },
  mapDrawSettings: window.mapDrawSettings,
  zernikeSet: window.zernikeSet,
  zernikeParams: window.zernikeParams
};
const mutations = {
  CASEPATH_CHANGED: (state, casePath) => {
    state.casePath = casePath;
  },
  DATASHOWSETTINGS_CHANGED: (state, value) => {
    state.dataShowSettings = objectCopy(value);
    window.dataShowSettings = objectCopy(value);
    saveDataShowSettings(window.dataShowSettings);
  },
  MAPDRAW_CHANGED: (state, value) => {
    if (!isDefined(value)) return;
    state.mapDrawSettings = objectCopy(value);
    window.mapDrawSettings = objectCopy(value);

    saveMapDrawSettings(window.mapDrawSettings);
  },
  ZERNIKESET_CHANGED: (state, value) => {
    state.zernikeSet = objectCopy(value);
    window.zernikeSet = objectCopy(value);
    saveZernikeSetSettings(window.zernikeSet);
  },
  ZERNIKE_VIEW_PARAMS_CHANGED: (state, value) => {
    state.zernikeViewParams = objectCopy(value);
    window.zernikeViewParams = objectCopy(value);
  },
  ZERNIKE_PARAMS_CHANGED: (state, value) => {
    state.zernikeParams = objectCopy(value);
    window.zernikeParams = objectCopy(value);
    saveZernikeParams(window.zernikeParams);
  }
};
const actions = {
  camraModeChanged({ commit }, casePath) {
    commit("CASEPATH_CHANGED", casePath);
  },
  dataShowSettingsChanged({ commit }, dataShowSettings) {
    commit("DATASHOWSETTINGS_CHANGED", dataShowSettings);
  },
  mapDrawSettingsChanged({ commit }, mapDrawSettings) {
    commit("MAPDRAW_CHANGED", mapDrawSettings);
  },
  zernikeSetChanged({ commit }, zernikeSet) {
    commit("ZERNIKESET_CHANGED", zernikeSet);
  },
  zernikViewParamsChanged({ commit }, zernIkeViewParams) {
    commit("ZERNIKE_VIEW_PARAMS_CHANGED", zernIkeViewParams);
  },
  zernikeParamsChanged({ commit }, zernikeParams) {
    commit("ZERNIKE_PARAMS_CHANGED", zernikeParams);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/topography.js